import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'accent' | 'soft' | 'ghost' | 'outline';
type Size = 'sm' | 'md' | 'lg' | 'xl';

const sizeStyles: Record<Size, string> = {
  sm: 'px-4 py-2 text-[13px]',
  md: 'px-[22px] py-3 text-[15px]',
  lg: 'px-[30px] py-4 text-base',
  xl: 'px-9 py-[18px] text-[17px]',
};

const variantStyles: Record<Variant, string> = {
  primary: 'bg-ink text-white',
  accent: 'bg-accent text-white',
  soft: 'bg-accent-soft text-accent-deep',
  ghost: 'bg-transparent text-ink',
  outline: 'bg-transparent text-ink shadow-[inset_0_0_0_1.5px_var(--color-hairline-strong)]',
};

interface C2ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  children?: ReactNode;
}

export default function C2Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}: C2ButtonProps) {
  return (
    <button
      {...rest}
      className={[
        'inline-flex items-center justify-center gap-2 rounded-pill font-semibold whitespace-nowrap',
        'font-body cursor-pointer border-0',
        'transition-[transform,box-shadow,background] duration-150 ease-out',
        'hover:-translate-y-0.5',
        sizeStyles[size],
        variantStyles[variant],
        className,
      ].join(' ')}
    >
      {children}
    </button>
  );
}
